import {
  GREEN_MAX_DAYS,
  NO_CONTACT_DAYS,
  YELLOW_MAX_DAYS,
  type ActivityLight,
  type Semaforo,
} from '@growup/streaming-shared';
import { StatusBadge, type StatusTone } from '@growup/ui';

export const LIGHT_LOOK: Record<ActivityLight, { label: string; tone: StatusTone; hint: string }> =
  {
    green: {
      label: 'Verde',
      tone: 'success',
      hint: `transmitiu nos últimos ${String(GREEN_MAX_DAYS)} dias`,
    },
    yellow: {
      label: 'Amarelo',
      tone: 'warning',
      hint: `${String(GREEN_MAX_DAYS + 1)} a ${String(YELLOW_MAX_DAYS)} dias sem transmitir`,
    },
    red: {
      label: 'Vermelho',
      tone: 'danger',
      hint: `mais de ${String(YELLOW_MAX_DAYS)} dias sem transmitir`,
    },
  };

/**
 * O semáforo de um streamer (GS3): activity light, "Sem contacto" (the
 * padrinho has not talked to them for 30+ days) and a late report.
 */
export function SemaforoBadges({ semaforo }: { semaforo: Semaforo | null }) {
  if (semaforo === null) return <span className="text-gu-ink-muted">—</span>;
  return (
    <span className="inline-flex flex-wrap gap-1">
      {semaforo.activity ? (
        <span title={LIGHT_LOOK[semaforo.activity].hint}>
          <StatusBadge tone={LIGHT_LOOK[semaforo.activity].tone} symbol="●">
            {LIGHT_LOOK[semaforo.activity].label}
          </StatusBadge>
        </span>
      ) : null}
      {semaforo.noContact ? (
        <span title={`O padrinho não fala com ele há mais de ${String(NO_CONTACT_DAYS)} dias`}>
          <StatusBadge tone="danger">Sem contacto</StatusBadge>
        </span>
      ) : null}
      {semaforo.checkupOverdue ? (
        <StatusBadge tone="warning">Relatório em atraso</StatusBadge>
      ) : null}
    </span>
  );
}
